/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2022, Zumper
 */

// https://chakra-ui.com/docs/styled-system/theming/component-style#styling-single-part-components

import type { ComponentStyleConfig } from '@chakra-ui/theme'
import { SystemStyleFunction, SystemStyleObject, mode } from '@chakra-ui/theme-tools'

import { focus } from '../sharedStyles/focus'

const baseStyle: SystemStyleObject = {
  control: {
    borderWidth: 1,
    borderRadius: 'base',
    borderColor: 'gray.500',
    _focus: focus,
  },
  label: {
    fontFamily: 'body',
  },
}

const variantMain: SystemStyleFunction = (props) => ({
  control: {
    background: mode('transparent', 'white')(props),
    borderColor: 'gray.500',
    _checked: {
      color: 'white',
      bg: 'pink.600',
      _hover: {
        bg: 'pink.600',
        borderColor: 'pink.600',
        color: 'white',
      },
    },
  },
})

const variants = {
  main: variantMain,
}

export const Z4Checkbox: ComponentStyleConfig = {
  defaultProps: {
    colorScheme: 'pink',
    size: 'md',
    variant: 'main',
  },
  baseStyle,
  variants,
}
